import React, { Suspense } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { MAX_LENGTH_POLL_OPTION } from "../../config";
import { IconAddPoll, IconBackV2, IconClose } from "../../icons/svg";
import Helpers from "../../lib/helpers";
import { sanitizeUrlForMime } from "../../lib/utils";
import GroupService from "../../services/group";
import { profile } from "../../stores/storages/ProfileStorage";
import { NODE_TYPE_MESSAGE } from "../../tinode/constants";
import MessagesUtil from "../../tinode/messagesUtils";
import { Topic } from "../../tinode/topic";
import CheckBox from "../check-box.jsx";
import LetterTile from "../letter-tile.jsx";

class PollMessage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = this.getBlankState();
    this.handleSetShowInfoVote = this.handleSetShowInfoVote.bind(this);
    this.getPollMessage = this.getPollMessage.bind(this);
    this.renderPollOptions = this.renderPollOptions.bind(this);
    this.handleClickVote = this.handleClickVote.bind(this);
    this.handleVote = this.handleVote.bind(this);
    this.renderUserVoteInOption = this.renderUserVoteInOption.bind(this);
    this.handleAddOrRemoveOption = this.handleAddOrRemoveOption.bind(this);
    this.renderAddPollOption = this.renderAddPollOption.bind(this);
    this.handleAddVote = this.handleAddVote.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.isAddPoll = this.isAddPoll.bind(this);
  }

  getBlankState() {
    const pollMessage = this.getPollMessage();
    const options = pollMessage?.options;
    let optionOldIds = [];
    if (options && options.length > 0) {
      const user = profile.username;
      optionOldIds = options.filter(v => {
        return v?.voters?.includes(user);
      }).map((v) => {
        return v.id;
      });
    }
    return {
      showInfoVote: false,
      pollMessage,
      optionOldIds,
      optionNewIds: optionOldIds,
      newOptions: [],
      userVote: [],
      titleVote: ''
    }
  }

  getPollMessage() {
    const { tinode, topic, pollMessageId } = this.props;
    const topicInfo = tinode.getTopic(topic);
    return topicInfo.findPollMessageById(pollMessageId);
  }

  handleSetShowInfoVote(boolean, userVote = [], titleVote = '') {
    this.setState({
      showInfoVote: boolean,
      userVote: userVote,
      titleVote: titleVote
    });
  }

  handleClickVote(id) {
    const { pollMessage, optionNewIds } = this.state;
    const choice = pollMessage.choice;
    var array = [...optionNewIds];
    if (choice == 1) {
      if (optionNewIds.includes(id)) {
        array = [];
      } else {
        array = [id];
      }
    } else {
      const index = array.indexOf(id);
      if (index == -1) {
        array.push(id);
      } else {
        array.splice(index, 1);
      }
    }
    this.setState({
      optionNewIds: array
    });
  }

  handleVote() {
    const { optionOldIds, optionNewIds } = this.state;
    const { pollMessageId, tinode, topic, onClose } = this.props;
    GroupService.vote(pollMessageId, JSON.stringify(optionNewIds), JSON.stringify(optionOldIds)).then((res) => {
      const { data, code } = res;
      if (code == 200) {
        tinode.updatePollMessage(topic, data, profile.username);
        onClose();
      }
    })
  }

  handleAddOrRemoveOption(type, index = 0) {
    const { newOptions } = this.state;
    var array = [...newOptions];

    if (type === 1) {
      array.push('');
    } else {
      array.splice(index, 1);
    }
    this.setState({
      newOptions: array
    })
  }

  handleAddVote(index) {
    const { pollMessageId, tinode, topic } = this.props;
    const { pollMessage, optionNewIds } = this.state;
    const options = pollMessage?.options;
    let option = this.state.newOptions[index];
    if (options && options.length > 0) {
      const check = options.find(v => v.title == option);
      if (check != undefined) {
        const { formatMessage } = this.props.intl;
        Helpers.showErrorToasts(formatMessage({
          id: "poll_error_add",
          defaultMessage: "Vote already exists. Please add another option",
        }));
        return;
      }
    }
    GroupService.addVote(pollMessageId, Topic.getThreadId(topic), '', JSON.stringify([option])).then((res) => {
      const { data, code } = res;
      if (code == 200) {
        tinode.addPollMessage(topic, data, profile.username).then((res) => {
          this.setState({
            pollMessage: this.getPollMessage()
          })
        });
        this.handleAddOrRemoveOption(2, index);
      }
    })
  }

  renderPollOptions() {
    const { pollMessage, optionNewIds } = this.state;

    const options = pollMessage?.options;
    if (options && options.length > 0) {
      return options.map((item, index) => {
        return (
          <div className="item-poll" key={index}>
            <div className="left">
              <CheckBox status={optionNewIds.includes(item.id)} onClick={() => this.handleClickVote(item.id)} />
            </div>
            <div className="right">
              <div className="option">{item.title}</div>
              <div className="list-vote" onClick={() => this.handleSetShowInfoVote(true, item.voters, item.title)}>
                {item.voters && this.renderUserVote(item.voters)}
              </div>
            </div>
          </div>
        )
      })
    }
  }

  renderUserVote(voters) {
    const { tinode } = this.props;
    const arr = voters.slice(0, 5);
    return arr.map((item, index) => {
      const topic = tinode.getTopicByName(MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, item));
      let name = topic.getTopicName();
      let avatar = null;
      if (tinode) {
        avatar = tinode.authorizeURL(sanitizeUrlForMime(topic?.public?.photo?.ref, 'image')) || true;
      }
      return (
        <div className="img" key={index}>
          <LetterTile
            tinode={tinode}
            avatar={avatar}
            topic={topic.user}
            title={name} />
        </div>
      )
    })
  }

  renderUserVoteInOption() {
    const { userVote, titleVote } = this.state;
    const { tinode } = this.props;
    return (
      <div className="info-poll-option">
        <div className="header">
          <div className="click" onClick={() => this.handleSetShowInfoVote(false)}>
            <IconBackV2 />
          </div>
          <div className="title">
            {titleVote} ({userVote.length})
          </div>
        </div>
        <div className="list-vote">
          {userVote.map((item, index) => {
            const topic = tinode.getTopicByName(MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, item));
            let name = topic.getTopicName();
            let avatar = null;
            if (tinode) {
              avatar = tinode.authorizeURL(sanitizeUrlForMime(topic?.public?.photo?.ref, 'image')) || true;
            }
            return (
              <div className="item">
                <div className="avatar-box">
                  <LetterTile
                    tinode={tinode}
                    avatar={avatar}
                    topic={topic.user}
                    title={name} />
                </div>
                <div className="name">
                  {name}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  onChangeInput(e, index) {
    let s = e.target.value;
    if (s.length > MAX_LENGTH_POLL_OPTION) {
      return;
    }
    let newOptions = [...this.state.newOptions];
    newOptions[index] = s;
    this.setState({
      newOptions: newOptions
    });
  }

  renderAddPollOption() {
    const { newOptions } = this.state;
    return newOptions.map((item, index) => {
      return (
        <div className="item-poll" key={index}>
          <div className="left" onClick={() => this.handleAddOrRemoveOption(2, index)} style={{ cursor: 'pointer' }}>
            <IconClose />
          </div>
          <div className="right">
            <div className="option">
              <input type="text" value={item} onChange={(e) => this.onChangeInput(e, index)} />
            </div>
            <div className="list-vote" onClick={() => this.handleAddVote(index)}>
              <button>
                Thêm
              </button>
            </div>
          </div>
        </div>
      )
    })
  }

  isAddPoll() {
    const {  pollMessage } = this.state;
    return pollMessage?.enableAddVote == 1 || pollMessage?.creator == profile.username;
  }

  render() {
    const { showInfoVote, pollMessage } = this.state;
    return (
      <Suspense
        fallback={
          <div className="panel-form-row">
            <FormattedMessage
              id="loading_note"
              defaultMessage="Loading..."
              description="Message shown when component is loading"
            />
          </div>
        }>
        {showInfoVote ?
          <React.Fragment>
            {this.renderUserVoteInOption()}
          </React.Fragment>
          :
          <div className="poll-message">
            <div className="header">
              <div className="title">
                {pollMessage?.title}
              </div>
              <div className="icon" onClick={this.props.onClose}>
                <IconClose />
              </div>
            </div>
            <div className="content-poll-message">
              {this.renderPollOptions()}
              {this.renderAddPollOption()}
              {this.isAddPoll() &&
                <div className="add-poll" onClick={() => this.handleAddOrRemoveOption(1)}>
                  <div className="left">
                    <IconAddPoll />
                  </div>
                  <div className="right">
                    <div className="option">
                      <FormattedMessage id="dialog_poll_add_option" defaultMessage="Add option" />
                    </div>
                  </div>
                </div>
              }
            </div>
            <div className="btn" onClick={this.handleVote}>
              <button>
                <FormattedMessage id="dialog_poll_button" defaultMessage="Voted" />
              </button>
            </div>
          </div>
        }
      </Suspense>
    )
  }
}
export default injectIntl(PollMessage);
